<template>
  <b-modal
    ref="modal"
    title="Selecione a embalagem"
    centered
    size="lg"
    no-close-on-backdrop
    @hidden="aoFechar"
  >
    <p class="mb-4">
      Escolha como <strong>{{ produto.descricao }}</strong> será vendido.
    </p>

    <b-list-group>
      <b-list-group-item
        v-for="embalagem in embalagens"
        :key="embalagem.id_produto_embalagem"
        button
        :active="idSelecionado === embalagem.id_produto_embalagem"
        class="d-flex align-items-center justify-content-between"
        @click="selecionar(embalagem)"
        @dblclick="confirmar"
      >
        <div>
          <strong>{{ descricaoUnidade(embalagem) }}</strong>
          <span
            v-if="embalagem.embalagem_padrao"
            class="badge badge-light ml-2"
          >
            Padrão
          </span>
          <span class="d-block small" :class="idSelecionado === embalagem.id_produto_embalagem ? 'text-white' : 'text-muted'">
            Baixa {{ formatarQuantidade(embalagem.fator_conversao) }}
            {{ descricaoUnidadeBase }} do estoque
            <template v-if="embalagem.cod_barras">
              · Cód. barras: {{ embalagem.cod_barras }}
            </template>
          </span>
        </div>
        <strong class="font-size-lg">
          {{ formatarMoeda(embalagem.preco) }}
        </strong>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <b-button variant="secondary" @click="cancelar">Cancelar</b-button>
      <b-button
        variant="primary"
        :disabled="!embalagemSelecionada"
        @click="confirmar"
      >
        Usar embalagem
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "EmbalagemProdutoModal",
  data() {
    return {
      produto: {},
      embalagens: [],
      idSelecionado: null,
      resolver: null,
    };
  },
  computed: {
    embalagemSelecionada() {
      return (
        this.embalagens.find(
          (embalagem) =>
            embalagem.id_produto_embalagem === this.idSelecionado
        ) || null
      );
    },
    descricaoUnidadeBase() {
      const unidade = this.produto?.unidade_medida || {};
      return unidade.sigla || unidade.un || unidade.nome || "unidades";
    },
  },
  methods: {
    abrir({ produto, embalagemSelecionada = null }) {
      if (this.resolver) this.resolver(null);

      this.produto = produto || {};
      const alternativas = Array.isArray(produto?.embalagens)
        ? produto.embalagens
        : [];
      this.embalagens = [
        {
          id_produto_embalagem: "__padrao__",
          embalagem_padrao: true,
          unidade_medida: produto?.unidade_medida || null,
          preco: produto?.preco,
          fator_conversao: 1,
          cod_barras: produto?.cod_barras || null,
        },
        ...alternativas,
      ];
      this.idSelecionado =
        embalagemSelecionada?.id_produto_embalagem ??
        (this.embalagens.length === 1
          ? this.embalagens[0].id_produto_embalagem
          : null);

      this.$refs.modal.show();

      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    selecionar(embalagem) {
      this.idSelecionado = embalagem.id_produto_embalagem;
    },
    confirmar() {
      if (!this.embalagemSelecionada) return;
      this.finalizar({ ...this.embalagemSelecionada });
    },
    cancelar() {
      this.finalizar(null);
    },
    finalizar(resultado) {
      const resolver = this.resolver;
      this.resolver = null;
      if (resolver) resolver(resultado);
      this.$refs.modal.hide();
    },
    aoFechar() {
      if (this.resolver) {
        this.resolver(null);
        this.resolver = null;
      }
    },
    descricaoUnidade(embalagem) {
      const unidade = embalagem?.unidade_medida || {};
      if (unidade.nome && unidade.sigla) {
        return `${unidade.nome} (${unidade.sigla})`;
      }
      return unidade.nome || unidade.sigla || unidade.un || "Embalagem";
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(valor) || 0);
    },
    formatarQuantidade(valor) {
      return new Intl.NumberFormat("pt-BR", {
        maximumFractionDigits: 4,
      }).format(Number(valor) || 0);
    },
  },
};
</script>
